import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import HeroSection from "./components/HeroSection";
import SolutionsSection from "./components/SolutionsSection";
import CtaSection from "./components/CtaSection";
import ServicesSection from "./components/ServicesSection";
import CoolnetSection from "./components/CoolnetSection";
import StatsSection from "./components/StatsSection";
import ClientsSection from "./components/ClientsSection";

export default function Home() {
  return (
    <Layout>
      <SEO
        title="Sistemas HVAC y Energía UPS en León, Guanajuato | Ventra Core"
        description="Especialistas en venta, instalación y mantenimiento de sistemas HVAC, congelación, refrigeración, sistemas eléctricos especializados y energía UPS en León, Guanajuato. Más de 15 años de experiencia."
        keywords="sistemas HVAC, climatización, aire acondicionado, refrigeración, congelación, sistemas eléctricos, energía UPS, León Guanajuato, centros de datos, Coolnet"
        canonical="https://ventracore.com.mx/"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": "https://ventracore.com.mx/#webpage",
            "url": "https://ventracore.com.mx/",
            "name": "Sistemas HVAC y Energía UPS en León, Guanajuato | Ventra Core",
            "isPartOf": { "@id": "https://ventracore.com.mx/#website" },
            "about": { "@id": "https://ventracore.com.mx/#organization" },
            "description": "Especialistas en sistemas HVAC, climatización y energía UPS en León, Guanajuato.",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
            ],
          },
        ]}
      />
      <HeroSection />
      <SolutionsSection />
      <CtaSection />
      <ServicesSection />
      <CoolnetSection />
      <ClientsSection />
      <StatsSection />
    </Layout>
  );
}